// extracted by mini-css-extract-plugin
export default {"error":"error_error__qCbmQ","error-big":"error_error-big__rUfFq"};